<template>
    <div class="selector_right">
    </div>
</template>

<script>
export default {
  name: 'Right',
  props: ['x', 'y'],
  data: () => ({}),
  computed: {}
}
</script>

<style scoped>
    .selector_right {
        background: url(~@/assets/lines/right.png);
        width: 250px;
        height: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/components/selector/Right.vue